<template>
  <div class="block pageSize" v-if="isShow">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationData.page"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="paginationData.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="paginationData.total">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    props: ['dataUrl','search', 'type'],
    created () {
      this.handlePageSizeChange()
    },
    data () {
      return {
        isShow: false,
        paginationData: {
          page:sessionStorage.getItem("page")==null?1:parseInt(sessionStorage.getItem("page")),
          size: 10,
          total: 0,
          start: '',
          end: '',
          type: this.type
        },
        isLoading: true
      }
    },
    watch: {  
  　　search: {  
　　　　handler(newValue, oldValue) {
　　　　 　　　for(var key in newValue){
            this.paginationData[key] = newValue[key]
          }
          this.paginationData.page = 1
          sessionStorage.setItem("paginationData", JSON.stringify(this.paginationData))
          this.handlePageSizeChange()　  
　　　　},  
　　　　deep: true  
  　　}  
    }, 
    methods: {
      // 改变页码
      handleSizeChange (val) {
        this.paginationData.size = val
        this.handlePageSizeChange()
      },
      // 改变当前页
      handleCurrentChange (val) {
        this.paginationData.page = val
        sessionStorage.setItem("paginationData", JSON.stringify(this.paginationData))
        sessionStorage.setItem("page", this.paginationData.page);
        this.handlePageSizeChange()
      },
      // 改变数据
      handlePageSizeChange () {
        this.isLoading = true
        this.paginationData = sessionStorage.getItem("paginationData")==null?this.paginationData:JSON.parse(sessionStorage.getItem("paginationData"));
        this.$http.post(this.dataUrl, this.paginationData)
          .then(res => {
            this.isLoading = false
            this.$emit('changeLoad', this.isLoading)
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            } else {
              if (res.total>=1) {
                this.isShow = true
              } else{
                this.isShow = false
              }
              this.paginationData.total = res.total 
              this.$emit('changeData', res.data)
              this.$emit('changeTotal', res.total)
              // 考勤统计特有
              this.$emit('changeKaoqin', res)
              // 邮箱管理-收件箱特有
              this.$emit('changeUnReadCount', {unReadCount: res.unReadCount, total: res.total})
              if (res.rules) {
                this.$emit('changeRules', res) 
              }                            
            }         
          })
          .catch(err => {
            this.isLoading = false
            console.log(err)
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/PageSize/index.vue